import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DashboardLog } from '@models/dashboardLog.model';

import { environment } from '@env/environment';
import { LocalService } from '@app/shared/services/local.service';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';
import { DatePipe } from '@angular/common';
const BASE_PATH = environment.basePathExternal
/**
 * Service class to communicate with the REST services
 */
@Injectable({
    providedIn: 'root',
})

export class DashboardLogService {
    portfolioCode : any;
    constructor(
        private datePipe: DatePipe,
        private profileManagerService: ProfileManagerService,
        private secureStorage:LocalService,
        protected httpClient: HttpClient
    ) {
         
        if (this.profileManagerService.isMasterBO() || this.profileManagerService.isOperatorBO()) {
            this.portfolioCode = null
        }
        else {
            if (this.secureStorage.getJsonValue('portfolioCode')) {
                this.portfolioCode = JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode
            }
            
           
      }
     }


    save(body?: DashboardLog): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
        return this.httpClient.post<any>(`${BASE_PATH}/dashboardLogs/save`, body, { headers: headers });
    }

    getFormattedDate(date){
        const currentDate = new Date(); // Date actuelle
        const hours = currentDate.getHours();
        const minutes = currentDate.getMinutes();
        const seconds = currentDate.getSeconds();
        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
       const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
       return new Date(`${formattedDate} ${formattedTime}`);
        
      }
    


    setDashboardLogCotas(type,modulo,subModule,status,fund,solicitationDate,fundValue,statusBefore,statusAfter){
        if (this.profileManagerService.isMasterBO() || this.profileManagerService.isOperatorBO()) {
            this.portfolioCode = null
        }
        else {
            if (this.secureStorage.getJsonValue('portfolioCode')) {
                this.portfolioCode = JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode
            }
            
           
      }
        solicitationDate = this.getFormattedDate(solicitationDate)
        let dashboardLog : DashboardLog = {
            application:"Armstrong",
            ptfCode:this.portfolioCode,
            type:type,
            module:modulo,
            subModule:subModule,
            status:status,
            fund:fund,
            solicitationDate:solicitationDate,
            fundValue:fundValue!=null?fundValue.toString():null,
            statusBefore:statusBefore,
            statusAfter:statusAfter,
        };
        this.save(dashboardLog).subscribe()
        
    }
    setDashboardLog(subModule,status,fund,solicitationDate){
        if (this.profileManagerService.isMasterBO() || this.profileManagerService.isOperatorBO()) {
            this.portfolioCode = null
        }
        else {
            if (this.secureStorage.getJsonValue('portfolioCode')) {
                this.portfolioCode = JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode
            }
            
           
      }
        solicitationDate = this.getFormattedDate(solicitationDate)
        let dashboardLog : DashboardLog = {
            application:"Armstrong",
            ptfCode:this.portfolioCode,
            type:"Consulta",
            module:"Dashboard",
            subModule:subModule,
            status:status,
            fund:fund,
            solicitationDate:solicitationDate
        };
        this.save(dashboardLog).subscribe()
        
    }
}
